module.exports = __webpack_public_path__ + "img/main_culture8.54c6b877.png";